/**
 * batch-68 controle (FO-342 §5 + FO-343 §6) — de urennotatie van de controles.
 *
 * Uren staan app-breed met twee decimalen (FO-305, `formatUren`). In de TVT-
 * controle leest u:mm vaak natuurlijker ("5:00", "-1:30"), dus per gebruiker is
 * er een schakelaar. Beide controles (verloning en facturatie) delen deze
 * helper en dezelfde voorkeur; de Excel-export toont beide notaties.
 */
import { formatUren } from './reistijd-format'

export const CONTROLE_URENNOTATIES = ['DECIMAAL', 'UMM'] as const
export type ControleUrennotatie = (typeof CONTROLE_URENNOTATIES)[number]

/**
 * Uren als u:mm, met teken: 5 -> "5:00", -1.5 -> "-1:30", 0.25 -> "0:15".
 * De minuten worden op hele minuten afgerond; ongeldig of leeg -> "0:00".
 */
export function formatUrenUmm(uren: number | null | undefined): string {
  if (uren == null || !Number.isFinite(uren)) return '0:00'
  const totaalMinuten = Math.round(Math.abs(uren) * 60)
  const u = Math.floor(totaalMinuten / 60)
  const m = totaalMinuten % 60
  const teken = uren < 0 && totaalMinuten > 0 ? '-' : ''
  return `${teken}${u}:${String(m).padStart(2, '0')}`
}

export interface FormatControleUrenOpties {
  /** Toon een plus-teken bij een positieve waarde ("+6,50"); voor mutaties. */
  metTeken?: boolean
}

/**
 * Uren in de gekozen notatie. Decimaal volgt `formatUren` (nl-NL, komma, twee
 * decimalen); u:mm volgt `formatUrenUmm`. Met `metTeken` krijgt een positieve
 * waarde een plus-teken (een negatieve heeft er altijd een min).
 */
export function formatControleUren(
  uren: number | null | undefined,
  notatie: ControleUrennotatie,
  opties: FormatControleUrenOpties = {},
): string {
  const waarde = uren == null || !Number.isFinite(uren) ? 0 : uren
  const tekst = notatie === 'UMM' ? formatUrenUmm(waarde) : formatUren(waarde)
  if (opties.metTeken && waarde > 0 && Math.round(waarde * 100) !== 0) return `+${tekst}`
  return tekst
}
